import React, { FC } from 'react';
import { cn } from '@global/utils/styling';
import './style.scss';

interface IProps {
  size?: string;
  withOverlay?: boolean;
  fullScreen?: boolean;
}

export const Spinner: FC<IProps> = ({ size, withOverlay, fullScreen }) => {
  const spinner = (
    <div
      className="spinner"
      style={size ? { width: size, height: size } : {}}
    ></div>
  );

  return (
    <div
      className={cn({
        fullScreen,
        overlay: withOverlay,
        'center-box': withOverlay || fullScreen,
      })}
    >
      {spinner}
    </div>
  );
};
